import { present } from '@/shared/overlay';
import type { AgreementCode } from '@/shared/data-types';
import { AgreementModal } from './agreement-modal';

/**
 * 약관 원문 모달을 앱 루트 슬롯에 명령형 mount. 트리거(footer 약관링크·동의폼 원문보기 등)는
 * 이 함수만 호출 — `<OverlayHost/>` 가 provider 하위에서 렌더하므로 모달 내부의 `useApiV2` 등이
 * 정상 동작. `key` 로 같은 약관이 이미 열려 있으면 재mount 안 함(연타 스택 방지).
 */
export function openAgreement(code: AgreementCode): void {
  present(
    ({ open, close }) => (
      <AgreementModal code={code} open={open} onOpenChange={(next) => !next && close()} />
    ),
    { key: `agreement:${code}` },
  );
}
